import { gql } from '@apollo/client';

export default gql`
  query timetableNewsById($id: ID!) {
    timetableNewsById(id: $id) {
      model {
        id
        severity
        category
        title {
          ...timetableNewsTranslations
        }
        description {
          ...timetableNewsTranslations
        }
        commercial {
          ...timetableNewsTranslations
        }
        dateStart
        dateEnd
        dateEffectStart
        dateEffectEnd
        dateUpdate
      }
      services {
        model {
          trainNumber
          serviceName
          serviceStatus
          carrier
        }
        serviceStops {
          model {
            arrivalStatus
            actualArrivalDateTime
            actualDepartureDateTime
            commercialArrivalDateTime
            commercialDepartureDateTime
            departureStatus
            expectedArrivalDateTime
            expectedDepartureDateTime
            scheduledDepartureDateTime
            scheduledArrivalDateTime
            stopNumber
            platformNumber
            date
          }
          station {
            uic
            shortCode
            name {
              ...timetableNewsTranslations
            }
          }
          news {
            model {
              id
              severity
              category
              title {
                ...timetableNewsTranslations
              }
              description {
                ...timetableNewsTranslations
              }
              commercial {
                ...timetableNewsTranslations
              }
              dateStart
              dateEnd
              dateEffectStart
              dateEffectEnd
              dateUpdate
            }
          }
        }
      }
    }
  }

  fragment timetableNewsTranslations on TimetableTranslations {
    en
    fr
    de
    nl
  }
`;
